"use client";

// ===========================================
// konakla - Auth Modal (yönlendirme kabuğu)
// ===========================================
// Giriş/kayıt akışının tek gerçek kaynağı /auth sayfasıdır (app/auth/page.tsx).
// Bu bileşen geriye dönük uyumluluk için korunur: açıldığında — mobil VE
// masaüstünde — kullanıcıyı /auth sayfasına yönlendirir. Böylece sitedeki tüm
// giriş/kayıt işlemleri tek bir yerde toplanır ve auth UI kopyası kalmaz.
//
// Yönlendirme render sırasında DEĞİL bir effect içinde yapılır: render sırasında
// router.push + setState çağırmak React'te uyarıya/hataya yol açıyordu.

import { useEffect } from "react";
import { useRouter } from "next/navigation";

interface AuthModalProps {
  isOpen: boolean;
  onClose: () => void;
  defaultMode?: "login" | "register";
  redirectTo?: string;
}

export function AuthModal({ isOpen, onClose, redirectTo = "/dashboard" }: AuthModalProps) {
  const router = useRouter();

  useEffect(() => {
    if (!isOpen) return;
    router.push(`/auth?redirect=${encodeURIComponent(redirectTo)}`);
    onClose();
    // onClose kasıtlı olarak dep listesinde değil — her render'da kimliği
    // değişiyor; yalnızca isOpen true olduğunda bir kez yönlendirmek istiyoruz.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpen, redirectTo, router]);

  return null;
}
